const route = {
	path: '/accouting-ats-rules',
	name: 'accouting-ats-rules',
	meta: {
		title: 'Reglas de Anexos Transaccionales',
	},
	component: () => import('@/pages/atsRules/ats-rules'),
};

export default route;



// WEBPACK FOOTER //
// ./src/router/ats-rules.js